import { applyCap } from "../score-caps";
import averageWPSScores, { totalScore } from "../average-wps-scores";
import expandable from "./higher-order/expandable";
import { FormattedScore } from "./formatted-currency";
import LightBox from "./light-box";
import pure from "./higher-order/pure";
import React from "react";

export default expandable(pure(function AverageScoreLightBox({ betType, expanded, text, toggle }) {
  var showHide = e => {
    e.stopPropagation();
    toggle();
  };

  var size = Math.ceil(averageWPSScores.length / 2);
  var leftRows = averageWPSScores.slice(0, size).map(a => <AverageScoreRow averageWPSScore={a} betType={betType} key={a.odds} />);
  var rightRows = averageWPSScores.slice(size).map(a => <AverageScoreRow averageWPSScore={a} betType={betType} key={a.odds} />);

  var lightbox;
  if (expanded) {
    lightbox = (
      <LightBox
        onClose={showHide} title={
          <span>
            <i className="dw-lamp3 dw--baseline" />

            {" "}
            Average Scores
          </span>
        }>
        <div className="lightbox_body">
          <p className="text--is-italic color--is-medium-gray">
            Payouts are estimated averages based on historical results.
          </p>

          <div className="batch-g">
            <div className="batch-c-1-1 batch-c-md-1-2 border-right--width-1-desktop">
              <table className="table--padding-is-small text-right margin-bottom--is-0">
                <thead>
                  <tr>
                    <th className="text-center">
                      Odds
                    </th>

                    <th className="text-right">
                      Payout
                    </th>

                    <th className="text-right">
                      Win
                    </th>

                    <th className="text-right">
                      Place
                    </th>

                    <th className="text-right">
                      Show
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {leftRows}
                </tbody>
              </table>
            </div>

            <div className="batch-c-1-1 batch-c-md-1-2">
              <table className="table--padding-is-small text-right margin-bottom--is-0">
                <thead className="hidden--mobile">
                  <tr>
                    <th className="text-center">
                      Odds
                    </th>

                    <th className="text-right">
                      Payout
                    </th>

                    <th className="text-right">
                      Win
                    </th>

                    <th className="text-right">
                      Place
                    </th>

                    <th className="text-right">
                      Show
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {rightRows}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="lightbox_footer">
          <button className="btn" onClick={showHide} type="button">
            Close
          </button>
        </div>
      </LightBox>
    );
  }
  return (
    <div>
      {lightbox}

      <button className="btn btn--tiny btn--naked" onClick={showHide} type="button">
        <i className="dw-lamp3 dw--1-25x" />

        <span className="link--is-underlined">
          {text}
        </span>
      </button>
    </div>
  );
}));

var AverageScoreRow = pure(function AverageScoreRow({ averageWPSScore, betType }) {
  var total = totalScore(averageWPSScore, betType);
  var scores = betType.split("").map(type => (
    <td className="color--is-medium-gray" key={type}>
      <FormattedScore value={applyCap(averageWPSScore[type], type)} />
    </td>
  ));
  return (
    <tr>
      <td className="text-center text--is-bold">
        {averageWPSScore.odds}
      </td>

      <td className="text--is-normal">
        <FormattedScore value={total} />
      </td>

      {scores}
    </tr>
  );
});
